// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","body":"_2lYHSCAcM6vA2s-47YYZeS","caption":"_1dJD2pSCq2-UhXWE_3mRfd","errorRed":"#ff2a2a","borderGrey":"#d5dfdf","mobileThreshold":"575px","small":"_22zGKWmKy0aZd_9Ue1eYfN","form":"_2hrKm_chVL5h-NO-CcpjTN","label":"_1cKuT_5SLM7i5R7XLjvJ7Z _2lYHSCAcM6vA2s-47YYZeS","labelMobile":"_3ftDIIhaBiCdMQpee61kMp _22zGKWmKy0aZd_9Ue1eYfN","error":"ZfoZYh47ca6Qf-SQ9HKgZ _1dJD2pSCq2-UhXWE_3mRfd","inputContainer":"tzVzfwzJpFYdxiCvQAkfY","input":"_2wEgOtlzTRoB804w5-_VLr","buttonContainer":"MgkIVxk-ifea14LPANuA-","button":"_1qF9W6Nm8rEAMbFO7HtPeq"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/my-account/edit-password/EditPassword.css
// module id = 553
// module chunks = 0 1 2